import '../styles/navbar.css';
import { Link, useLocation } from 'react-router-dom';

function NavBar() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  const navItems = [
    { href: "#hero", label: "Kezdőlap" },
    { href: "#about", label: "Rólam" },
    { href: "#results", label: "Eredmények" },
    { href: "#marketingservices", label: "Szolgáltatások" },
    { href: "#contact", label: "Kapcsolat" },

  ];

  return (
    <div className="container-fluid navbar-wrapper">
      <div className="container">
        <nav className="navbar navbar-expand-md navbar-dark px-3">
          <Link to="/" className="navbar-brand mx-2 navbar-brand-custom">
            FRDYPromotions
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarsExample04"
            aria-controls="navbarsExample04"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse text-center" id="navbarsExample04">
            <ul className="navbar-nav ms-auto">
              {navItems.map((item, index) => (
                <li className="nav-item mx-2 my-1" key={index}>
                  {item.absolute || !isHome ? (
                    <Link to={item.absolute ? item.href : `/${item.href}`} className="nav-link navbar-link">
                      {item.label}
                    </Link>
                  ) : (
                    <a href={item.href} className="nav-link navbar-link">
                      {item.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default NavBar;
